import { useCopyToClipboard } from '@gogame/hooks-ts';
import { useScreenMessage } from '@gogame/screens';

export const useCopyCampaignHybridLink = () => {
  const { showSuccessMessage } = useScreenMessage();
  const copyToClipboard = useCopyToClipboard();
  return ({ hybridLink }) => {
    copyToClipboard(hybridLink);
    showSuccessMessage('Campaign hybrid link copied to clipboard');
  };
};
